import React from "react";
import { INDIAN_STATES, INDIAN_CITIES, DOC_STATUS_OPTIONS } from "../../lib/constants";
import { toast } from "sonner";
import { PartySelector } from "./PartySelector";

// Date, party, place of supply, reference, status, document number and supply-type badge.
export function DocHeaderCard({ form, setForm, cfg, docType, mode, parties, partyMode, setPartyMode, setQuickPartyOpen,
  lookupPincode, series, isAdmin, missingNumbers, totals, company }) {
  return (
  <div className="card-base p-6 grid grid-cols-1 md:grid-cols-4 gap-4">
    <div>
      <div className="label-overline block mb-1.5">Date *</div>
      <input type="date" className="field" data-testid="doc-date" value={form.doc_date} onChange={e => setForm({ ...form, doc_date: e.target.value })} />
    </div>
    <div className="md:col-span-3 grid grid-cols-1 gap-3">
      <PartySelector form={form} setForm={setForm} cfg={cfg} parties={parties} partyMode={partyMode} setPartyMode={setPartyMode}
        onQuickAdd={() => setQuickPartyOpen(true)} lookupPincode={lookupPincode} />
    </div>
    <datalist id="indian-cities-list">{INDIAN_CITIES.map(c => <option key={c} value={c} />)}</datalist>
    <div>
      <div className="label-overline block mb-1.5">Place of Supply</div>
      <select className="field" data-testid="doc-pos" value={form.place_of_supply_state_code} onChange={e => setForm({ ...form, place_of_supply_state_code: e.target.value })}>
        <option value="">Auto (from party)</option>
        {INDIAN_STATES.map(s => <option key={s.code} value={s.code}>{s.code} - {s.name}</option>)}
      </select>
    </div>
    <div>
      <div className="label-overline block mb-1.5">Reference</div>
      <input className="field" data-testid="doc-reference" value={form.reference} onChange={e => setForm({ ...form, reference: e.target.value })} />
    </div>
    <div>
      <div className="label-overline block mb-1.5">Status</div>
      <select className="field" data-testid="doc-status" value={form.status} onChange={e => setForm({ ...form, status: e.target.value })}>
        {(DOC_STATUS_OPTIONS[docType] || ["draft", "sent", "accepted", "rejected", "cancelled"]).map(s => (
          <option key={s} value={s}>{s.charAt(0).toUpperCase() + s.slice(1)}</option>
        ))}
        {!DOC_STATUS_OPTIONS[docType] && docType === "invoice" && <option value="paid">Paid</option>}
        {!DOC_STATUS_OPTIONS[docType] && (docType === "delivery_challan" || docType === "gate_pass") && <option value="dispatched">Dispatched</option>}
      </select>
    </div>
    {mode === "new" && (
      <div>
        <div className="label-overline block mb-1.5 flex items-center justify-between">
          <span>{cfg.label} No.</span>
          {series?.[docType] && <span className="text-[10px] text-ink-muted normal-case tracking-normal">Auto: {series[docType].prefix}-{series[docType].include_year ? new Date().getFullYear() + "-" : ""}{String(series[docType].next_number || 1).padStart(series[docType].pad || 4, "0")}</span>}
        </div>
        <input className="field font-mono uppercase" placeholder="(auto-generated)" data-testid="doc-number-override" value={form.doc_number_override} onChange={e => setForm({ ...form, doc_number_override: e.target.value.toUpperCase() })} />
        {isAdmin && missingNumbers.length > 0 && (
          <div className="mt-1.5">
            <select
              className="field !py-1.5 text-xs"
              data-testid="missing-number-select"
              value=""
              onChange={e => {
                const mn = missingNumbers.find(m => m.doc_number === e.target.value);
                if (!mn) return;
                setForm(f => ({ ...f, doc_number_override: mn.doc_number }));
                toast.info(`Date must be between ${mn.prev_date} and ${mn.next_date}`, { duration: 4000 });
              }}
            >
              <option value="">⚠ Fill a missing serial ({missingNumbers.length})…</option>
              {missingNumbers.map(m => (
                <option key={m.doc_number} value={m.doc_number}>{m.doc_number} (date {m.prev_date} → {m.next_date})</option>
              ))}
            </select>
          </div>
        )}
      </div>
    )}
    <div className="md:col-span-2">
      <div className="label-overline block mb-1.5 flex items-center justify-between">
        <span>Supply Type</span>
        <span className={`status-pill ${totals.isInterState ? "status-info" : "status-success"}`}>{totals.isInterState ? "Inter-state (IGST)" : "Intra-state (CGST+SGST)"}</span>
      </div>
      <div className="text-xs text-ink-muted">Company state: <span className="font-mono">{company?.state_code || "09"}</span> · Destination: <span className="font-mono">{totals.destState || "—"}</span></div>
    </div>
  </div>
  );
}
